let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("claFy")).then(() => parcelRequire('3sSbK'));